// Single source of runtime configuration.
//
// One row per environment. The row is selected by REACT_APP_ENV, passed inline by
// the npm scripts (see package.json):
//   npm start            -> development (REACT_APP_ENV unset, NODE_ENV=development)
//   npm run build:stage  -> stage
//   npm run build:prod   -> production
// No .env files are used while the app is on CRA (it cannot select a third
// environment file without an extra tool). Nothing else in src/ should read
// process.env. When this app moves to Vite the rows move to .env.<mode> files
// and the selector becomes import.meta.env.MODE.
//
// Nothing here is secret: Firebase web config and API URLs ship in the bundle.

const STAGE_FIREBASE = {
  apiKey: 'AIzaSyArTMdVwEpts1FkQyb74QBbBb2JbYSlPnc',
  authDomain: 'stage-summa-app.firebaseapp.com',
  projectId: 'stage-summa-app',
  storageBucket: 'stage-summa-app.appspot.com',
  messagingSenderId: '715245215526',
  appId: '1:715245215526:web:8bec0fcc4b31fed6a9abe7',
  measurementId: 'G-2W2J9S4YFM',
}

const PROD_FIREBASE = {
  apiKey: 'AIzaSyAQhahA99OnLqxtzDymzv19D0LuTEu9UZc',
  authDomain: 'summa-app-cf50e.firebaseapp.com',
  projectId: 'summa-app-cf50e',
  storageBucket: 'summa-app-cf50e.appspot.com',
  messagingSenderId: '145379822464',
  appId: '1:145379822464:web:b271f2825b75f429950f65',
  measurementId: 'G-HTZY987710',
}

// Backend = the fixed `api` Cloud Function of each project (summa-app-eng,
// deployed with `firebase deploy -P stage|prod --only functions:api`).
// OAuth callbacks must equal the backend's OURA/WHOOP_REDIRECT_URI for the same
// project (functions/.env.<project-id>) and what is registered with the provider;
// localhost is not registered, so development reuses the stage callbacks.
const DEVELOPMENT = {
  apiBaseUrl: 'https://api-skujycwmdq-ew.a.run.app',
  landingUrl: 'http://localhost:3000',
  firebase: STAGE_FIREBASE,
  ouraRedirectUri: 'https://stage-summa-app.web.app/redirect_oura',
  whoopRedirectUri: 'https://stage-summa-app.web.app/redirect_whoop',
}

// https://stage-summa-app.web.app (default hosting site of stage-summa-app)
const STAGE = {
  apiBaseUrl: 'https://api-skujycwmdq-ew.a.run.app',
  landingUrl: 'https://stage-summa-app.web.app',
  firebase: STAGE_FIREBASE,
  ouraRedirectUri: 'https://stage-summa-app.web.app/redirect_oura',
  whoopRedirectUri: 'https://stage-summa-app.web.app/redirect_whoop',
}

// https://app.summa.bio (default hosting site of summa-app-cf50e)
const PRODUCTION = {
  apiBaseUrl: 'https://api-ct4brcf5aa-ew.a.run.app',
  landingUrl: 'https://app.summa.bio',
  firebase: PROD_FIREBASE,
  ouraRedirectUri: 'https://app.summa.bio/redirect_oura',
  whoopRedirectUri: 'https://app.summa.bio/redirect_whoop',
}

const VERSION_WEB = 'v0.9.0'
const VERSION_API = 'api (eng master)'

// CRA inlines process.env.* as string literals, so this chain of comparisons is
// folded at build time and only the selected environment's values end up in the
// bundle (verify with: grep -o 'https://[a-z0-9.-]*run.app' build/static/js/main.*.js).
const env =
  process.env.REACT_APP_ENV ||
  (process.env.NODE_ENV === 'development' ? 'development' : undefined)

const selected =
  env === 'production'
    ? PRODUCTION
    : env === 'stage'
      ? STAGE
      : env === 'development'
        ? DEVELOPMENT
        : null

if (!selected) {
  throw new Error(
    `[config] Unknown or missing REACT_APP_ENV "${env}". ` +
      'Build with npm start / npm run build:stage / npm run build:prod.'
  )
}

const config = {
  env, // 'development' | 'stage' | 'production'
  ...selected,
  versionWeb: VERSION_WEB,
  versionApi: VERSION_API,
}

export default config
